import {Platform, StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {white} from '/theme/color/on.color';
import {alto, darkRed, salmonPink} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {
    flex: 1,
    backgroundColor: white,
  },
  header: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 16,
    marginTop: indent * 0.5,
    paddingLeft: indent,
  },
  label: {
    paddingLeft: indent,
    marginBottom: indent * 0.1,
  },
  inputBox: {
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: alto,
    backgroundColor: white,
    width: '90%',
    marginLeft: indent * 1,
    borderRadius: indent * 0.4,
    marginBottom: indent * 1,
    height: 50,
  },
  inputText: {
    paddingLeft: indent * 0.5,
    ...(Platform.OS === 'web' && {outlineStyle: 'none'}),
  },
  inputError: {
    borderColor: salmonPink,
    marginBottom: indent * 0.1,
    height: 50,
  },
  errorLabel: {
    paddingLeft: indent * 1,
    marginBottom: 12,
    color: darkRed,
  },
  container: {
    marginBottom: 0,
    paddingBottom: 0,
  },
});
